<template>
    <div>
        <radio-list :name="'warehouse'" :items="rubrics" v-model="rubric" />
        <keep-alive>
              <component :is="rubric"/>
        </keep-alive>
    </div>
</template>
<script>
export default {
  watch: {
  },
  name: "warehouse",
  components:{
      options: () => import("../components/Warehouse/Options"),
      brands: () => import("../components/Warehouse/Brands"),
      categories: () => import("../components/Warehouse/Categories"),
      names: () => import("../components/Warehouse/Names"),
      features: () => import("../components/Warehouse/Features"),
      values: () => import("../components/Warehouse/Values"),
      products: () => import("../components/Warehouse/Products"),
      stickers: () => import("../components/Warehouse/Stickers"),
  },
  data() {
    return {
        rubric:'options',
        rubrics:[
            {
              title:'Вариации товаров',
              id:'options'
            },
            {
              title:'Товары',
              id:'products'
            },
            {
              title:'Бренды',
              id:'brands'
            },
              {
              title:'Классы',
              id:'names'
            },
            {
              title:'Категории',
              id:'categories'
            },
            {
              title:'Группы характеристик',
              id:'features'
            },
            {
              title:'Значения характеристик',
              id:'values'
            },
            {
              title:'Наклейки',
              id:'stickers'
            },
          ]
    };
  },
};
</script>
<style>
</style>
